import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import beforeAsset from "@/assets/before-stair.jpg.asset.json";
import afterAsset from "@/assets/after-stair.jpg.asset.json";

const beforeImg = beforeAsset.url;
const afterImg = afterAsset.url;
import { SectionHeading } from "./SectionHeading";

export function BeforeAfter() {
  return (
    <section className="section-light">
      <div className="container-x py-20 md:py-28">
      <div className="grid gap-12 lg:grid-cols-2 items-center">
        <div>
          <SectionHeading
            eyebrow="The Transformation"
            title="From Cracked Concrete To Factory-Finish In A Day."
            body="Unlike DIY kits or basic floor paint, our coatings are diamond-ground into the concrete for maximum adhesion — creating a seamless, durable, easy-to-clean surface that lasts for decades."
          />
          <ul className="mt-8 space-y-3">
            {[
              "Up to 5× stronger than standard DIY epoxy",
              "Industrial-grade polyaspartic top coat",
              "Backed by our written warranty",
            ].map((b) => (
              <li key={b} className="flex items-start gap-3 text-silver">
                <span className="mt-2 h-1.5 w-1.5 rounded-full bg-copper shrink-0" />
                <span className="text-sm md:text-base">{b}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/quote"
            className="mt-8 inline-flex items-center gap-2 rounded-sm bg-copper px-7 py-4 text-sm font-bold uppercase tracking-wider text-white hover:bg-copper-hover transition-colors"
          >
            See What Yours Could Look Like <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <figure className="relative overflow-hidden rounded-sm border border-border">
            <img src={beforeImg} alt="Plywood stairs in garage before epoxy coating" className="aspect-[4/5] w-full object-cover" loading="lazy" />
            <figcaption className="absolute left-3 top-3 rounded-sm bg-jet/85 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-silver-light">
              Before
            </figcaption>
          </figure>
          <figure className="relative overflow-hidden rounded-sm border border-copper/50 mt-8">
            <img src={afterImg} alt="Finished epoxy coated stairs in garage" className="aspect-[4/5] w-full object-cover" loading="lazy" />
            <figcaption className="absolute left-3 top-3 rounded-sm bg-copper px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white">
              After
            </figcaption>
          </figure>
        </div>
      </div>
      </div>
    </section>
  );
}
